module.exports = "./img/desktop_logo.09bfdc6.png";